import { PhoneField, useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { PHONE_CALL_KINDS } from '../../constants';
import { AdditionalInfo } from '../additional_info';
const wrapperCss = "w1t52kac";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const InboundCallDetails = ({
  kind,
  fieldNamePrefix,
  onKeyPress
}) => {
  const phoneNumberFieldName = `${fieldNamePrefix}.phoneNumber`;
  const {
    setFieldTouched,
    setFieldValue
  } = useFormContext();
  const [{
    value: currentValue
  }] = useFormField({
    name: phoneNumberFieldName
  });

  // Trigger validation when component mounts for inbound calls
  // This is a workaround to trigger validation when the component mounts
  // and the phone number is empty for the Rspec tests
  useEffect(() => {
    if (kind === PHONE_CALL_KINDS.inbound && !currentValue) {
      setFieldValue(phoneNumberFieldName, ' ', false);
      setFieldTouched(phoneNumberFieldName, true, true);
      setTimeout(() => {
        setFieldValue(phoneNumberFieldName, '', false);
      }, 0);
    }
  }, [kind, phoneNumberFieldName, setFieldTouched, setFieldValue, currentValue]);
  if (kind !== PHONE_CALL_KINDS.inbound) return null;
  return <Wrapper>
      <PhoneField name={phoneNumberFieldName} aria-label={I18n.t('publisher.event_types.invitee_questions.custom.phone_number')} onKeyDown={onKeyPress} />
      <AdditionalInfo fieldNamePrefix={fieldNamePrefix} />
    </Wrapper>;
};

require("./inbound_call_details.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./inbound_call_details.js");